import { EFeatureFlags } from 'constants/features';
import { useIsFeatureEnabled } from 'hooks/useFeatures';
import { Globe } from 'lucide-react';
import { Icon } from 'ui';
import { ICreateReferenceMutation, IReferences } from 'modules/threads/types';
import { IGetDrawingResponse } from 'modules/billOfMaterials/types';
import { useCreateDrawingMutation, useDeleteDrawingMutation } from 'modules/billOfMaterials/bomApi';
import { handleDrawing } from 'modules/billOfMaterials/helpers';

export const CopilotDataNotice = () => {
  const copilotEnabled = useIsFeatureEnabled(EFeatureFlags.COPILOT);
  return copilotEnabled ? (
    <div className="rounded bg-secondary p-4 text-xs">
      <div className="mb-2 flex flex-row items-center gap-2 text-sm font-semibold">
        <Globe className="h-3 w-3" /> Data Usage Notice
      </div>
      <p>We&apos;re using your data to enhance our services with a Large Language Model (LLM).</p>

      <p>
        Your privacy is our priority. For details, click{' '}
        <a
          href="https://www.authentise.com/help-pages/threads/understanding-our-large-language-model-llm"
          className="text-link"
          target="_blank"
          rel="noreferrer"
        >
          here
        </a>
        .
      </p>
    </div>
  ) : null;
};

export const Threads3dIcon = () => (
  <div className="flex items-center justify-center gap-1 rounded-sm bg-threads-3d p-1">
    <div className="rounded-sm bg-dark1 p-1">
      <Icon icon="Threads3dIcon" size="normal" />
    </div>
  </div>
);

export const PlyableIcon = () => (
  <div className="flex items-center justify-center gap-1 rounded-sm bg-plyable p-1">
    <div className="rounded-sm bg-dark1 p-1">
      <Icon icon="PlyableLogo" size="normal" />
    </div>
  </div>
);

type CreateDrawingTrigger = ReturnType<typeof useCreateDrawingMutation>[0];
type DeleteDrawingTrigger = ReturnType<typeof useDeleteDrawingMutation>[0];

export type THandleSubmit = {
  payload: Omit<ICreateReferenceMutation, 'thread'>;
  reference?: IReferences;
  referenceDrawing?: IGetDrawingResponse | null;
  createDrawing: CreateDrawingTrigger;
  deleteDrawing: DeleteDrawingTrigger;
  drawing: boolean;
  onSubmit: (payload: Omit<ICreateReferenceMutation, 'thread'>) => Promise<IReferences>;
};

export const handleReferenceSubmit = async ({
  payload,
  referenceDrawing,
  createDrawing,
  deleteDrawing,
  onSubmit,
  drawing,
}: THandleSubmit) => {
  const createdReference = await onSubmit?.(payload);
  if (!createdReference?.id) return;

  await handleDrawing({
    drawing,
    referenceDrawing,
    createdReference,
    createDrawing,
    deleteDrawing,
    showSuccessMessage: false,
  });
};
